import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const JourneyExit = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.06249 6.11099C8.51812 6.11099 8.88749 6.48036 8.88749 6.93599V8.06099C8.88749 8.14056 8.91909 8.21686 8.97536 8.27312C9.03162 8.32939 9.10792 8.36099 9.18749 8.36099H12.5625C13.0797 8.36099 13.5756 8.56644 13.9413 8.93213C14.307 9.29783 14.5125 9.79382 14.5125 10.311V11.436C14.5125 11.8916 14.1431 12.261 13.6875 12.261C13.2319 12.261 12.8625 11.8916 12.8625 11.436V10.311C12.8625 10.2314 12.8309 10.1551 12.7746 10.0989C12.7184 10.0426 12.6421 10.011 12.5625 10.011H9.18749C8.67032 10.011 8.17433 9.80555 7.80863 9.43985C7.44293 9.07415 7.23749 8.57816 7.23749 8.06099V6.93599C7.23749 6.48036 7.60685 6.11099 8.06249 6.11099ZM17.0625 13.986C17.5181 13.986 17.8875 14.3554 17.8875 14.811V18.186C17.8875 18.7032 17.682 19.1992 17.3163 19.5649C16.9506 19.9305 16.4547 20.136 15.9375 20.136H13.6875C13.2319 20.136 12.8625 19.7666 12.8625 19.311C12.8625 18.8554 13.2319 18.486 13.6875 18.486H15.9375C16.0171 18.486 16.0934 18.4544 16.1496 18.3981C16.2059 18.3419 16.2375 18.2656 16.2375 18.186V14.811C16.2375 14.3554 16.6069 13.986 17.0625 13.986Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.38749 17.886V19.611H12.8625V17.886H4.38749ZM2.73749 17.6235C2.73749 16.8572 3.35869 16.236 4.12499 16.236H13.125C13.8913 16.236 14.5125 16.8572 14.5125 17.6235V19.8735C14.5125 20.6398 13.8913 21.261 13.125 21.261H4.12499C3.35869 21.261 2.73749 20.6398 2.73749 19.8735V17.6235Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1375 12.261V13.986H19.6125V12.261H11.1375ZM9.48749 11.9985C9.48749 11.2322 10.1087 10.611 10.875 10.611H19.875C20.6413 10.611 21.2625 11.2322 21.2625 11.9985V14.2485C21.2625 15.0148 20.6413 15.636 19.875 15.636H10.875C10.1087 15.636 9.48749 15.0148 9.48749 14.2485V11.9985Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.38749 4.38599V6.11099H12.8625V4.38599H4.38749ZM2.73749 4.12349C2.73749 3.3572 3.35869 2.73599 4.12499 2.73599H13.125C13.8913 2.73599 14.5125 3.3572 14.5125 4.12349V6.37349C14.5125 7.13979 13.8913 7.76099 13.125 7.76099H4.12499C3.35869 7.76099 2.73749 7.13979 2.73749 6.37349V4.12349Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
